module.exports = __webpack_public_path__ + "img/zhongxinGH2.6e7df5b1.png";